import { useTranslation } from 'react-i18next';
import { Box } from "@mui/material";
import CustomTitleBox from "../centralComponents/CustomTitleBox";

export default function Imprint() {
    const { t } = useTranslation();

    return (
        <CustomTitleBox title={t("imprint")} >
            <Box textAlign="center">
                AT-Corporation OG <br />
                Offene Gesellschaft <br />
                <br />
                IT-Dienstleistung <br />
                UID-Nr.: <br />
                FN.: <br />
                Sitz: Kreuzsalweg 10 A-5550 Radstadt | Österreich <br />
                Tel.: +43 660 <br />
                E-Mail: info@at-corporation.at <br />
                <br />
                Mitglied der WKÖ <br />
                Berufsrecht: <br />
                Gewerbeordnung: www.ris.bka.gv.at <br />
                Bezirkshauptmannschaft St. Johann im Pongau <br />
            </Box>
        </CustomTitleBox>
    );
}